import _ from 'lodash';
import GatewayService from '../../GatewayService.js';
import log from '../../log.js';
import { missingParam } from '../../errors.js';
import scoreHelper from '../../helpers/score-helper.js';
var feedback = new GatewayService('feedbacktwo');

var saveManualScore = function saveManualScore(userKey, cardstackKey, unitKey, manualScoreText, breadcrumb) {
  if (_.isEmpty(userKey)) {
    log.error('Not saving manual score because no userKey was specified');
    return Promise.reject(missingParam('userKey'));
  }

  if (_.isEmpty(cardstackKey)) {
    log.error('Not saving manual score because no cardstackKey was specified');
    return Promise.reject(missingParam('cardstackKey'));
  }

  if (_.isEmpty(unitKey)) {
    log.error('Not saving manual score because no unitKey was specified');
    return Promise.reject(missingParam('unitKey'));
  }

  if (breadcrumb) {
    var body = {
      manualScoreText: manualScoreText,
      breadcrumb: breadcrumb
    };
    var url = "manualScore/user/".concat(userKey, "/unit/").concat(unitKey, "/cardstack/").concat(cardstackKey);
    return feedback.post(url, body)["catch"](function (err) {
      log.warn('Unable to save manual score: ', err);
      throw err;
    });
  }

  var params = {
    userBusinessKey: userKey,
    unitBusinessKey: unitKey,
    cardstackBusinessKey: cardstackKey
  };
  return feedback.post('manualScore', manualScoreText, {
    params: params
  })["catch"](function (err) {
    log.warn('Unable to save manual score: ', err);
    throw err;
  });
};

var saveAllManualScores = function saveAllManualScores() {
  var userKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var cardstackBusinessKey = arguments.length > 1 ? arguments[1] : undefined;
  var unitBusinessKey = arguments.length > 2 ? arguments[2] : undefined;
  var score = arguments.length > 3 ? arguments[3] : undefined;
  var breadcrumb = arguments.length > 4 ? arguments[4] : undefined;

  if (_.isEmpty(userKeys)) {
    log.error('Not saving manual score because no userKey was specified');
    return Promise.reject(missingParam('userKeys'));
  }

  if (_.isEmpty(cardstackBusinessKey)) {
    log.error('Not saving manual score because no cardstackBusinessKey was specified');
    return Promise.reject(missingParam('cardstackBusinessKey'));
  }

  if (_.isEmpty(unitBusinessKey)) {
    log.error('Not saving manual score because no unitBusinessKey was specified');
    return Promise.reject(missingParam('unitBusinessKey'));
  }

  var params = userKeys.map(function (userBusinessKey) {
    return {
      userBusinessKey: userBusinessKey,
      cardstackBusinessKey: cardstackBusinessKey,
      unitBusinessKey: unitBusinessKey,
      score: score,
      breadcrumb: breadcrumb
    };
  });
  return feedback.post('bulk/manualScore', params)["catch"](function (err) {
    log.warn('Unable to save scores: ', err);
    throw err;
  });
};

var fetchAllManualScores = function fetchAllManualScores() {
  var userKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var cardstackKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (_.isString(userKeys)) userKeys = [userKeys];
  if (_.isString(cardstackKeys)) cardstackKeys = [cardstackKeys];
  var manualScoreCalls = []; // TODO: Replace with the POST call with list of user keys which isn't working atm.

  for (var i = 0; i < userKeys.length; i++) {
    for (var j = 0; j < cardstackKeys.length; j++) {
      manualScoreCalls.push(feedback.get("manualScore/".concat(userKeys[i], "/cardstack/").concat(cardstackKeys[j])));
    }
  }

  return Promise.all(manualScoreCalls);
};

var fetchLatestManualScore = function fetchLatestManualScore() {
  var userKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var cardstackKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (_.isString(userKeys)) userKeys = [userKeys];
  if (_.isString(cardstackKeys)) cardstackKeys = [cardstackKeys];
  return fetchAllManualScores(userKeys, cardstackKeys).then(function (results) {
    return scoreHelper.getLastUpdatedManualScore(_.first(results));
  });
};

var sendManualScore = function sendManualScore(userKey, cardstackKey) {
  return fetchLatestManualScore(userKey, cardstackKey).then(function (latestManualScore) {
    var manualScore = _.isArray(latestManualScore) ? _.first(latestManualScore) : latestManualScore; // not firing the POST if the score has been submitted already

    if (!manualScore || manualScore.submittedDate) {
      return Promise.resolve();
    }

    return feedback.post('manualScore/submit', manualScore.businessKey);
  });
};

var saveAndSendManualScore = function saveAndSendManualScore(userKey, cardstackKey, unitKey, manualScore) {
  return saveManualScore(userKey, cardstackKey, unitKey, manualScore).then(function () {
    return sendManualScore(userKey, cardstackKey);
  })["catch"](function (err) {
    log.warn('Unable to save and send score: ', err);
  });
};

var markManualScoreAsRead = function markManualScoreAsRead(manualScoreKey) {
  return feedback.put("manualScore/".concat(manualScoreKey, "/read"));
};

var markAllManualScoresAsRead = function markAllManualScoresAsRead(manualScoreKeys) {
  return feedback.post("manualScore/read", manualScoreKeys.join(','));
};

export default {
  fetchAllManualScores: fetchAllManualScores,
  fetchLatestManualScore: fetchLatestManualScore,
  saveManualScore: saveManualScore,
  saveAllManualScores: saveAllManualScores,
  saveAndSendManualScore: saveAndSendManualScore,
  sendManualScore: sendManualScore,
  markManualScoreAsRead: markManualScoreAsRead,
  markAllManualScoresAsRead: markAllManualScoresAsRead
};